import { useState } from 'react';

import { useGetMousePositionFromEvent } from './useMousePositionFromEvent';

export const useCharacterDrag = () => {
  const getMousePositionFromEvent = useGetMousePositionFromEvent();

  const [isBeingDragged, setIsBeingDragged] = useState(false);

  const [dragOffsetX, setDragOffsetX] = useState(0);
  const [dragOffsetY, setDragOffsetY] = useState(0);

  return {
    isBeingDragged,
    startDrag: (charX: number, charY: number, event: React.MouseEvent) => {
      setIsBeingDragged(true);

      const { x: mouseX, y: mouseY } = getMousePositionFromEvent(event);

      const mouseOffsetX = mouseX - charX;
      const mouseOffsetY = mouseY - charY;

      setDragOffsetX(mouseOffsetX);
      setDragOffsetY(mouseOffsetY);
    },
    drag: (
      event: React.MouseEvent,
      dragCallback: (newX: number, newY: number) => void
    ) => {
      if (isBeingDragged) {
        const { x: mouseX, y: mouseY } = getMousePositionFromEvent(event);

        const newX = mouseX - dragOffsetX;
        const newY = mouseY - dragOffsetY;

        dragCallback(newX, newY);
      }
    },
    stopDrag: () => {
      setIsBeingDragged(false);
    },
  };
};
